/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "abe1935829c90ffc7568567aa021b0fea7790b2c";
